export enum RADashboardTabId {
  Overview = "overview",
  FactorLens = "factorlens",
  Holdings = "holdings"
}